import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { validateAccountNumber } from '../../../../../../../utils/Sweden/validateAccountNumber';

const accountNumberErrorMessage = 'AccountNumber.error.pattern';

export const accountNumberFieldOptions = {
  maxLength: 10,
  registerOptions: {
    deps: 'LoanApplication/ClearingNumber',
    required: 'AccountNumber.error.required',
    setValueAs: (value: string) => value.trim(),
    validate: (value, form) => {
      const clearingNumber = form['LoanApplication/AccountClearingNumber'];

      if (!clearingNumber) return 'AccountClearingNumber.error.required';

      try {
        const validationResponse = validateAccountNumber.safeParse(value);

        if (validationResponse.success) {
          return true;
        }
      } catch (error) {
        console.warn('Account number error', error);
        return accountNumberErrorMessage;
      }

      return accountNumberErrorMessage;
    },
  },
} satisfies IFieldOptions;
